import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const FloatingBookNowBtn = () => {
  const location = useLocation();
  const navigation = useNavigate();

  useEffect(() => {
    // Check if we're on one of the allowed paths
    const allowedPaths = ['/home'];
    const currentPath = location.pathname;

    if (allowedPaths.includes(currentPath)) {
      // Create button element
      const booknowBtn = document.createElement('div');
      booknowBtn.id = "floating-booknow-btn";
      booknowBtn.innerHTML = `
        <button
           style="background-color: transparent;position:fixed; bottom:20px; right:20px; z-index:9999; width:60px; height:60px;
                   border-radius:50%; display:flex; align-items:center;
                  justify-content:center;
                  border:none; outline:none; cursor:pointer; padding:0;
                  transition:all 0.3s ease;"
           onmouseover="this.style.transform='scale(1.1)'"
           onmouseout="this.style.transform='scale(1)'">
        <img src="/Book_now.svg" alt="Book Now" style="width:60px; height:60px;" />
        </button>
      `;

      // Add click event listener
      const handleClick = (e: any) => {
        e.preventDefault();
        navigation("/enquiry");
      };

      booknowBtn.addEventListener("click", handleClick);

      // Add to body
      document.body.appendChild(booknowBtn);

      // Cleanup function
      return () => {
        booknowBtn.removeEventListener("click", handleClick);
        const btn = document.getElementById("floating-booknow-btn");
        if (btn) {
          btn.remove();
        }
      };
    } else {
      // Remove button if not on allowed paths
      const btn = document.getElementById("floating-booknow-btn");
      if (btn) {
        btn.remove();
      }
    }
  }, [location.pathname, navigation]);

  return null;

};

export default FloatingBookNowBtn;